var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-admin-body"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"d-flex"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{staticClass:"new-competitive-dashboard"},[_c('saved-dashboard-cards',{attrs:{"client-object":_vm.$parent.$data.clientObject,"save-client-chart-object":_vm.clientChart}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }